import { Theme } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { useContext } from "react"
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import { AppContext } from "Views/Home/context"
import { InitialModalSimple } from "Methods/modal"

const ModalSimple = () => {
    const { appModalSimple, handleChangeModalSimple } = useContext(AppContext)
    const {
        title, show,
        timeout = 1000000,
        children = null
    } = appModalSimple

    if (timeout) {
        setTimeout(() => {
            handleChangeModalSimple(InitialModalSimple)
        }, timeout)
    }
    return (
        <Dialog
            open={show}
            disableBackdropClick={true}
            BackdropProps={{
            }}
        >
            <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
            {children}
        </Dialog>
    )
}

export default ModalSimple
